import React from 'react';

import styled from 'styled-components';

import {ReactComponent as CalendarIcon} from 'assets/svg/calendar.svg';
import {colors} from 'theme';

import {Icon} from '../Icon';
import {Input, InputProps} from '../Input';
import {Label} from '../Label';

interface DatePickerInputProps extends InputProps {
    placeholder?: string;
    className?: string;
    label?: string;
    hasError?: boolean;
}

const CustomInput = styled(Input)`
    input {
        cursor: pointer;
    }
`;

export class DatePickerInput extends React.Component<DatePickerInputProps> {
    render() {
        const {label, hasError, ...otherProps} = this.props;
        return (
            <Label text={label} hasError={hasError}>
                <CustomInput
                    {...otherProps}
                    adornment={
                        <Icon source={CalendarIcon} width={16} fillColor={colors.brandPrimary} />
                    }
                    hasError={hasError}
                    disableAdornmentPointerEvents
                />
            </Label>
        );
    }
}
